const permanentDomain = 'wyld-gummies.myshopify.com';

const processCartWithRecharge = () => {
  let checkout_url = '/checkout';
  function get_cookie(name) {
    return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2];
  }
  let token;
  let ga_linker;
  do {
    token = get_cookie('cart');
  } while (token == undefined);
  try {
    ga_linker = ga.getAll()[0].get('linkerParam');
  } catch (err) {
    ga_linker = '';
  }
  checkout_url =
    'https://checkout.wyldcbd.com/r/checkout?myshopify_domain=' +
    permanentDomain +
    '&cart_token=' +
    token +
    '&' +
    ga_linker;
  window.location = checkout_url;
};

export default processCartWithRecharge;
